/*
 * Response History Viewer module.  Handles showing the old response and possibly
 * rolling back the current response to the old version.
 */

define([
  "marionette",
  "i18n/i18n",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicResponseHistoryModal/topicResponseHistoryViewer/topicResponseHistoryViewerView",
], function (Marionette, i18next, Messenger, TopicResponseHistoryViewerView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicResponseHistoryViewer";
      this.region = options.region;
      this.hideRollback = options.hideRollback;
    },
    show: function (historyModel) {
      this.view = new TopicResponseHistoryViewerView.topicResponseHistoryViewerView({
        model: historyModel,
      });

      this.historyModel = historyModel;

      this.view.on("rollback", this._rollback, this);
      this.showRegion(this.view);
      if (this.hideRollback) {
        this.view.hideRollbackButton();
      }
    },
    _rollback: function () {
      Messenger.yesNoDialog(i18next.t("topic.responseHistory.rollback.warning"), {
        yes: () => {
          //disable the rollback button, since the rollback has already occurred
          this.view.disableRollbackButton();
          //send the old response to the current response
          Messenger.vent.trigger("rollback:topic:response", this.historyModel.get("response"));
        },
      });
    },
  });
});
